import React, { useEffect, useState } from "react";
import { Warning } from "@phosphor-icons/react";
import api from "../lib/api";

// Worker Reliability R1 — background import only when a fresh consumer heartbeat exists.
export function useWorkerHealth(active) {
  const [online, setOnline] = useState(false);
  useEffect(() => {
    if (!active) return undefined;
    let alive = true;
    const check = () => api.get("/jobs/worker-health")
      .then(({ data }) => alive && setOnline(data?.healthy === true))
      .catch(() => alive && setOnline(false));
    check();
    const t = setInterval(check, 30000);
    return () => { alive = false; clearInterval(t); };
  }, [active]);
  return [online, setOnline];
}

export function WorkerOfflineNotice({ online }) {
  if (online) return null;
  return (
    <div className="flex items-start gap-2 border border-amber-300 bg-amber-50 text-amber-900 text-xs p-2" data-testid="worker-offline-notice">
      <Warning size={14} weight="bold" className="mt-0.5 shrink-0" />
      <span>Background import worker is offline — background import is unavailable. Use the direct import below (validation, matching, pricing and duplicate checks still apply).</span>
    </div>
  );
}
